<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				@row-dblclick='rowClick'
				@sort-change='sortChangeHandle'
				:height="tableHeight"
			>
				<el-table-column
					prop="name"
					label="员工姓名"
					min-width="100"
					align="center">
				</el-table-column>
				<el-table-column
					prop="sumcommissionmoneybytime"
					label="检索区间提成金额"
					sortable="custom"
					min-width="180"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.sumcommissionmoneybytime}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="commissionmoneybytime"
					label="检索区间勾销提成金额"
					sortable="custom"
					min-width="190"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.commissionmoneybytime}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="nocommissionmoneybytime"
					label="检索区间未勾销提成金额"
					sortable="custom"
					min-width="200"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.nocommissionmoneybytime}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="auditingmoneybytime"
					label="检索区间已审核提成金额"
					sortable="custom"
					min-width="200"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.auditingmoneybytime}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="unauditingmoneybytime"
					label="检索区间未审核提成金额"
					sortable="custom"
					min-width="200"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.unauditingmoneybytime}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="ordercount"
					min-width="180"
					label="检索区间提成订单数"
					align="center">
				</el-table-column>
				<el-table-column
					prop="sumcommissionmoney"
					label="提成金额总计"
					min-width="180"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.sumcommissionmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="commissionmoney"
					label="勾销提成金额总计"
					min-width="180"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.commissionmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="nocommissionmoney"
					label="未勾销提成金额总计"
					min-width="180"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.nocommissionmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="auditingmoney"
					label="已审核提成金额总计"
					min-width="180"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.auditingmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="unauditingmoney"
					label="未审核提成金额总计"
					min-width="180"
					sortable="custom"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.unauditingmoney}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="getDetail(scope.row)" v-if="AuthorityList['11_0002_0002_00']">提成明细</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handlePageChange"
			:current-page="pagination.page"
			:page-sizes="[20, 40, 60, 100, 300]"
			:page-size="pagination.size"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalCount">
		</el-pagination>
	</div>
</template>

<script>
export default {
	name: 'mainTable',
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		dateValue: {
			type: Array
		},
		needauditingflag: Boolean,
		canundeliveredunpaysendflag: Boolean
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			}
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
	},
	methods: {
		rowClick (row, column, event) {
			if (this.AuthorityList['11_0002_0002_00']) {
				this.getDetail(row)
			}
		},
		selectionChangeHandle (value) {
			let ids = value.map(item => {
				return item.orderid
			})
			this.$emit('selectIds', ids)
		},
		sortChangeHandle (data) {
			// console.log(data)
			if (data.order === null) {
				this.$emit('sortSearch', { orderKey: '', orderBy: '' })
			} else {
				let orderBy = data.order === 'descending' ? 'desc' : 'asc'
				this.$emit('sortSearch', { orderKey: data.prop, orderBy: orderBy })
			}
		},
		getDetail (value) {
			this.$router.push({ path: '/main/achievementDetail', query: { staff: value.staffname, dateValue: this.dateValue } })
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
	}
}
</style>
<style lang="stylus">
.main-table {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
}
</style>
